import React from 'react';
import { HeroIcon } from './NavIcons';

// Брендовый попап перед системным диалогом Telegram requestWriteAccess
// (решение 2026-08-17): своё окно объясняет «зачем», системный диалог (его
// текст менять нельзя) только фиксирует согласие. Показывается лишь открывшим
// мини-апп без Старта бота — см. canAskWriteAccess в platform.js.
//
// Стиль — на классах checkout-overlay/checkout-modal и CSS-переменных
// бренд-пака (как WebAuthModal): STEMS и BLOOOOM получают каждый свой вид
// без правок здесь.
// Тексты по ступеням (согласованы 2026-08-17): при открытии человек ещё
// ничего не заказал — говорим нейтрально; на «Оформить» — прямо про заказ.
const TEXTS = {
  open: {
    title: 'Оставайтесь на связи',
    text: 'Разрешите боту писать вам — пришлём только важное: подтверждение и статус заказа.',
  },
  checkout: {
    title: 'Уведомления о заказе',
    text: 'Если вы хотите получать уведомления о статусе заказа, разрешите боту писать вам.',
  },
};

function NotifyPermissionPopup({ isOpen, stage = 'open', onAllow, onLater }) {
  if (!isOpen) return null;
  const { title, text } = TEXTS[stage] || TEXTS.open;

  return (
    <div
      className="checkout-overlay"
      style={{ zIndex: 2000, alignItems: 'center', padding: '0 20px' }}
      onClick={(e) => { if (e.target === e.currentTarget) onLater(); }}
    >
      <div
        className="checkout-modal"
        style={{ maxWidth: '340px', borderRadius: '16px', padding: '28px 24px', textAlign: 'center' }}
      >
        <div style={{ marginBottom: '12px' }}>
          <HeroIcon name="bell" size={48} />
        </div>
        <h3 style={{ margin: '0 0 10px', fontSize: '18px', color: 'var(--text-color)' }}>
          {title}
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '14px', lineHeight: 1.45, color: 'var(--text-color)', opacity: 0.75 }}>
          {text}
        </p>
        <button className="primary-btn" style={{ width: '100%' }} onClick={onAllow}>
          Разрешить
        </button>
        <button
          type="button"
          onClick={onLater}
          style={{
            width: '100%', marginTop: '10px', padding: '12px',
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--text-color)', opacity: 0.55, fontSize: '14px',
          }}
        >
          Позже
        </button>
      </div>
    </div>
  );
}

export default NotifyPermissionPopup;
